var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGreenAddWhiteBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#E4E5F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3624 39.875C39.3624 40.225 39.0874 40.5 38.7374 40.5H17.2625C16.9125 40.5 16.6375 40.225 16.6375 39.875C16.6375 34.7 21.7374 30.5 27.9999 30.5C29.2874 30.5 30.5375 30.675 31.6875 31.0125C30.95 31.8875 30.4999 33.025 30.4999 34.25C30.4999 35.1875 30.7624 36.075 31.2249 36.825C31.4749 37.25 31.7999 37.6375 32.1749 37.9625C33.0499 38.7625 34.2124 39.25 35.4999 39.25C36.8999 39.25 38.1625 38.675 39.0625 37.75C39.2625 38.425 39.3624 39.1375 39.3624 39.875Z",
    fill: "#353A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28C31.4518 28 34.25 25.2018 34.25 21.75C34.25 18.2982 31.4518 15.5 28 15.5C24.5482 15.5 21.75 18.2982 21.75 21.75C21.75 25.2018 24.5482 28 28 28Z",
    fill: "#353A75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0063 28.9313C40.6563 27.3938 38.65 26.4375 36.4375 26.4375C34.3375 26.4375 32.425 27.3 31.0563 28.7063C29.7438 30.0563 28.9375 31.9125 28.9375 33.9375C28.9375 35.3438 29.3312 36.675 30.025 37.8C30.4 38.4375 30.8875 39.0187 31.45 39.5062C32.7625 40.7062 34.5062 41.4375 36.4375 41.4375C39.175 41.4375 41.5563 39.975 42.85 37.8C43.2438 37.1625 43.5438 36.4312 43.7125 35.6812C43.8625 35.1187 43.9375 34.5375 43.9375 33.9375C43.9375 32.025 43.2063 30.2625 42.0063 28.9313ZM39.25 35.3062H37.8438V36.7688C37.8438 37.5375 37.2063 38.175 36.4375 38.175C35.6687 38.175 35.0312 37.5375 35.0312 36.7688V35.3062H33.625C32.8563 35.3062 32.2188 34.6687 32.2188 33.9C32.2188 33.1312 32.8563 32.4937 33.625 32.4937H35.0312V31.1625C35.0312 30.3938 35.6687 29.7563 36.4375 29.7563C37.2063 29.7563 37.8438 30.3938 37.8438 31.1625V32.4937H39.25C40.0188 32.4937 40.6562 33.1312 40.6562 33.9C40.6562 34.6687 40.0188 35.3062 39.25 35.3062Z",
    fill: "#29CD3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreenAddWhiteBg);
export default __webpack_public_path__ + "static/media/user-green-add-white-bg.827f14b3ba798ac648fca7ae5daf0b01.svg";
export { ForwardRef as ReactComponent };